export * from './table.component';
export * from './interfaces';
